<template>
  <div>
    <Dialog :header="$t('uyari')" v-model:visible="display">
      {{ message }}
    </Dialog>

    <Dialog
      v-model:visible="refer"
      modal
      :style="{
        width: '550px',
        background: '#FFFFFF',
        'box-shadow': ' 0px 0px 12px 2px rgba(0, 0, 0, 0.12)',
        'border-radius': '6px',
      }"
    >
      <template #header>
        <label style="font-weight: 700; font-size: 20px; color: #103660">
          {{ product.short_name + ' / ' + product.company_name }}
        </label>
      </template>

      <Refer :webpage="false" :product="product" @hide-dialog="hideDailog" />
    </Dialog>

    <Dialog
      v-model:visible="apply"
      modal
      :style="{
        width: '550px',
        background: '#FFFFFF',
        'box-shadow': ' 0px 0px 12px 2px rgba(0, 0, 0, 0.12)',
        'border-radius': '6px',
      }"
    >
      <template #header>
        <label style="font-weight: 700; font-size: 20px; color: #103660">
          {{ $t('apply') }}
        </label>
        <!-- </label> -->
      </template>
      <Apply :product="product" @hide-dialog="hideDailog" />
    </Dialog>

    <div
      class="absolute"
      style="
        position: absolute;
        width: 452px;
        height: 454px;
        left: -134px;
        top: 73px;
        background: rgba(1, 92, 172, 0.08);
        filter: blur(100px);
        z-index: 1;
      "
    >
      <img loading="lazy" src="/img/Ellipse.png" />
    </div>
    <div style="display: flex; align-items: center; flex-direction: column">
      <!-- left: 283px;top: 217px;position: absolute">  -->

      <span
        class="absolute"
        style="
          position: absolute;
          width: 452px;
          height: 454px;
          left: 479px;
          top: 48.81px;
          background: rgba(1, 92, 172, 0.08);
          filter: blur(100px);
          z-index: 1;
          @media (max-width: 1385px) {
            display: none;
          }
        }"
      ></span>

      <div class="formm" style="margin-top: 5rem">
        <form @submit.prevent="handleLogin()" class="p-fluid">
          <div class="input-panel job-search-wrapper">
            <div class="p-inputgroup loc">
              <span class="p-inputgroup-addon" style="display: none">
                <i class="pi pi-user"></i>
              </span>

              <div class="p-float-label">
                <MultiSelect
                  display="chip"
                  id="location"
                  :loading="loading"
                  v-model="location"
                  :options="countries"
                  optionLabel="description"
                  :filter="true"
                  class="multiselect-custom"
                  :class="{ 'p-invalid': notvalid }"
                  :style="{
                    'border-color': notvalid ? errorBorderColor : '#DBDBDB',
                    'border-style': 'solid',
                    'border-width': '1px',
                    'border-radius': '6px',
                    'box-sizing': 'border-box',
                    width: '406px',
                    height: '47px',
                  }"
                >
                  <template #value="slotProps">
                    <div
                      class="country-item country-item-value flex items-center"
                      style="gap: 4px"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div class="d-flex align-items-center">
                        <i :class="`fi fi-${option.iso2.toLowerCase()}`"></i>
                        <div class="ml-2">
                          {{ option.iso2 }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #option="slotProps">
                    <div
                      v-if="slotProps.option"
                      class="d-flex align-items-center"
                    >
                      <i
                        :class="`fi fi-${slotProps.option.iso2.toLowerCase()}`"
                      ></i>
                      <div class="ml-2">{{ slotProps.option.description }}</div>
                    </div>
                  </template>
                </MultiSelect>
                <i
                  :style="{
                    position: 'absolute',
                    top: '50%',
                    transform: 'translate(10px, -50%)',
                    'z-index': 99,
                    'font-size': '130%',
                    color: notvalid ? errorBorderColor : '#DBDBDB',
                  }"
                  class="pi pi-map-marker"
                ></i>
                <label
                  style="
                    font-size: medium;
                    margin-left: 2rem;
                    font-family: 'Jost';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 17px;
                    color: #444444;
                  "
                  for="location"
                  :class="{ 'p-error': notvalid }"
                  :style="notvalid ? colorRed : ''"
                >
                  {{ notvalid ? $t('locationm') + '*' : $t('locationm') }}
                </label>
                <!-- <InputText id="location" v-model="v$.location.$model" :class="{'p-invalid':v$.location.$invalid && submitted}"
                              :style="{'border-color':(v$.location.$invalid && submitted)?errorBorderColor:'#DBDBDB','border-style':'solid','border-width':'1px','border-radius':'6px','box-sizing':'border-box', width: '406px',height: '47px','padding-left':'2.5rem' }"/>
                              <i style="position: absolute;top: 50%;transform: translate(10px, -50%);z-index: 99;font-size: 130%;color: #DBDBDB" class="pi pi-map-marker"></i>
                              <label style="font-size: medium;margin-left: 2rem;font-family: 'Jost';font-style: normal;font-weight: 400;font-size: 12px;line-height: 17px;color: #444444;" for="location" :class="{'p-error':v$.location.$invalid && submitted}"
                                :style="(v$.location.$invalid && submitted)?colorRed:''">
                                {{(v$.location.$invalid && submitted)?$t("locationm")+"*":$t("locationm")}}
                              </label> -->
              </div>
              <!-- <small  style="position: absolute; pointer-events: none;top: 50%;margin-top: -.5rem;font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 10px;line-height: 16px;color: rgba(48, 57, 82, 0.6);" >
                        {{ $t('enterlocation') }}
                   </small> -->
            </div>
            <div class="divider"></div>
            <div class="p-inputgroup key">
              <span class="p-inputgroup-addon" style="display: none">
                <i class="pi pi-lock" />
              </span>
              <div class="p-float-label">
                <InputText
                  type="keyword"
                  id="keyword"
                  v-model="keyword"
                  @input="filterTable($event.target.value, 'keyword')"
                  @change="handleKeywordChange"
                  :style="{
                    'border-color': '#DBDBDB',
                    'border-style': 'solid',
                    'border-width': '1px',
                    'border-radius': '6px',
                    'box-sizing': 'border-box',
                    width: '406px',
                    height: '47px',
                    'padding-left': '2.5rem',
                  }"
                  :class="{ 'p-invalid': notvalid }"
                />
                <i
                  :style="{
                    position: 'absolute',
                    top: '50%',
                    transform: 'translate(10px, -50%)',
                    'z-index': 99,
                    'font-size': '130%',
                    color: notvalid ? errorBorderColor : '#DBDBDB',
                  }"
                  class="pi pi-search"
                ></i>
                <label
                  style="
                    font-size: medium;
                    margin-left: 2rem;
                    font-family: 'Jost';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 17px;
                    color: #444444;
                  "
                  for="keyword"
                  :class="{ 'p-error': notvalid }"
                  :style="notvalid ? colorRed : ''"
                >
                  {{ notvalid ? $t('keyword') + '*' : $t('keyword') }}
                </label>
              </div>
              <!-- <small  style="position: absolute; pointer-events: none;top: 50%;margin-top: -.5rem;font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 10px;line-height: 16px;color: rgba(48, 57, 82, 0.6);" >
                        {{ $t('enterkeyword') }}
                   </small> -->
            </div>
            <div class="button-group">
              <Button
                type="submit"
                class="button-refer"
                :label="$t('findjob')"
                style="width: 123px; height: 41px"
              />
              <Button
                class="button-apply"
                @click="getAllJobs"
                :label="$t('alljob')"
                style="width: 123px; height: 41px"
              />
            </div>
          </div>
        </form>
      </div>

      <!-- Main Filter Redio Buttons -->
    </div>

    <HomeFilter
      :key="filterComponentKey"
      :dateposted-prop="date_Posted"
      :jobtypes-prop="job_Type"
      :worktype-prop="work_Type"
      @clear-click="clear"
      :filter-length="filterLength"
      @result-click="result"
      @toggle-click="toggle"
      @radio-button-change="filterTable"
      :isFilter="isFilter"
    />
    <div v-if="!showEmptyState">
      <HomeDataTable
        @apply-click="applyToJob"
        @refer-click="referToJob"
        @detail-job="detailJob"
        :job-openings="jobOpenings"
        :job-openings-loading="jobOpeningsLoading"
        :topsize="topsize"
      />
    </div>
    <div v-else>
      <EmptyState
        :show-clear-filters="isFilter"
        :title="emptyStateTitle"
        :description="emptyStateDescription"
        @clear-filters="handleClearFilters"
        @view-all="getAllJobs"
      />
    </div>
  </div>
</template>

<script>
import { get, post } from '../api/Services'
import HomeDataTable from './HomeDataTable.vue'
import HomeFilter from './HomeFilter.vue'
import { setItem, getItem, removeItem } from '../store/localStorage'
import moment from 'moment'
import Refer from '../components/Refer.vue'
import Apply from '../components/Apply.vue'
import { mapState } from 'vuex'
import EmptyState from '@/components/EmptyState.vue'

export default {
  name: 'Home',
 
  data() {
    return {
      errorBorderColor: '#B00020',
      colorRed: { color: '#B00020' },
      location: '',
      keyword: '',
      word: '',
      user: {},
      isFilter: false,
      jobdesc: null,
      loading: true,
      jobOpeningsLoading: true,
      topsize: false,
      jobOpenings: [],
      jobFilters: [],
      submitted: false,
      countries: [],
      jobResult: [],

      searchKey: false,
      filterLength: null,
      date_Posted: 'Any',
      job_Type: 'All Job Types',
      work_Type: 'Any',
      product: {},
      refer: false,
      apply: false,
      createdjobtypes: [],
      jobTypes: '',
      workTypes: '',
      datePosteds: '',
      filetrs: {},
      notvalid: false,
      isOpen: false,
      tableFilter: {
        location: [],
        keyword: null,
        radiobutton: null,
      },
      filterData: [],
      filterComponentKey: 0,
    }
  },

  // computed: {
  //   // loggedIn() {
  //   //   return this.$store.state.auth.status.loggedIn;
  //   // }
  // },

  created() {
    this.getCountries()
    this.jobOpeningsLoading = true

    if (getItem('search-parameter')) {
      this.location = getItem('search-parameter').location
      this.keyword = getItem('search-parameter').keyword
      this.jobOpenings = getItem('jobOpenings')
      this.filterTable(this.location, 'location')
      this.filterTable(this.keyword, 'keyword')
      this.jobOpeningsLoading = false
    }
    get('JobTypes').then((data) => {
      if (data) {
        this.createdjobtypes = data
      }
    })

    if (
      getItem('jobOpenings') == false ||
      getItem('jobOpenings') == null ||
      getItem('jobOpenings') == undefined
    ) {
      this.handleLogin('tumveriler')
    } else {
      this.jobOpenings = getItem('jobOpenings')
      this.jobResult = getItem('jobOpenings')
      if (
        getItem('filters') != undefined ||
        getItem('filters') != null ||
        getItem('filters') != false
      ) {
        this.filetrs = getItem('filters')
      }
      this.jobOpeningsLoading = false
    }
    // get("/Countries").then((data) => {
    //     if (data) {
    //       this.countries = data
    //     }
    //   })
    // this.identifyCode = '';
    // this.makeCode(this.identifyCodes, 4);
  },
  watch: {
    location: {
      handler(newValue) {
        if (
          newValue.length > 0 ||
          this.tableFilter.keyword ||
          this.tableFilter.radiobutton
        ) {
          this.isFilter = true
        } else {
          this.isFilter = false
        }
      },
      deep: true,
    },

    keyword: {
      handler(newValue) {
        // Update filter state based on keyword value
        if (newValue && newValue.trim() !== '') {
          this.isFilter = true
        } else if (
          this.tableFilter.location.length === 0 &&
          !this.tableFilter.radiobutton
        ) {
          this.isFilter = false
        }
      },
    },

    tableFilter: {
      handler(newValue) {
        if (newValue) {
          this.radioButtonFilter(this.tableFilter)

          if (
            this.tableFilter.keyword ||
            this.tableFilter.location.length > 0 ||
            this.tableFilter.radiobutton
          ) {
            this.isFilter = true
          } else {
            this.isFilter = false
          }
        }
      },
      deep: true,
      /*
         Also very important the immediate in case you need it,
         the callback will be called immediately after the start
         of the observation
     */
      //  immediate: true
    },
  },

  methods: {
    async getCountries() {
      this.loading = true
      let parameters = []

      await post('/Commons/Executer', { sqlId: 71 }, JSON.stringify(parameters))
        .then((data) => {
          this.countries = data
        })
        .catch((err) => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: err.message,
            life: 3000,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    searchRemove(id) {
      this.location = this.location.filter((item) => item.id !== id)
    },

    filterTable(value, type) {
      if (type == 'radiobutton') {
        this.tableFilter[type] = value.jobTypes
      }
      if (type == 'location') {
        if (value.length == 0) {
          this.tableFilter[type] = []
        } else {
          if (!this.tableFilter.location.includes(value.at(-1).id)) {
            this.tableFilter[type].push(value.at(-1).id)
          }
        }
      }
      if (type == 'keyword') {
        if (value && value.trim() !== '') {
          this.tableFilter[type] = value
        } else {
          this.tableFilter[type] = null
        }
      }
    },
    hideDailog() {
      this.refer = false
      this.apply = false
    },
    applyToJob(data) {
      const loggedIn = JSON.parse(getItem('loggeduser'))
      if (loggedIn) {
        this.product = { ...data }
        this.apply ? (this.apply = false) : (this.apply = true)
      } else {
        this.$router.push({
          name: 'login',
          query: { redirect: this.$route.fullPath },
        })
      }
    },
    referToJob(data) {
      const loggedIn = JSON.parse(getItem('loggeduser'))
      if (loggedIn) {
        this.product = { ...data }
        this.refer ? (this.refer = false) : (this.refer = true)
      } else {
        this.$router.push({
          name: 'login',
          query: { redirect: this.$route.fullPath },
        })
      }
    },
    radioButtonFilter(value) {
      if (this.isOpen) {
        return
      }

      typeof value.keyword == 'number'
        ? (value = String(value.keyword))
        : value.keyword

      this.filterData = this.jobResult

      if (
        value.keyword ||
        value.location.length > 0 ||
        (value.radiobutton != 'All Job Types' && value.radiobutton != 'Any')
      ) {
        this.jobOpenings = this.jobResult

        this.jobOpenings = this.jobOpenings.filter((each) => {
          if (
            value.keyword != null &&
            value.location.length == 0 &&
            value.radiobutton == null
          ) {
            return (
              (each.location_country_name && value.keyword
                ? each.location_country_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase())
                : false) ||
              (each.location_city_name && value.keyword
                ? each.location_city_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase())
                : false) ||
              (each.short_name && value.keyword
                ? each.short_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase())
                : false) ||
              (each.company_name && value.keyword
                ? each.company_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase())
                : false) ||
              (each.reward && value.keyword
                ? String(each.reward).includes(value.keyword)
                : false)
            )
          }
          if (
            (value.keyword == null || value.keyword == '') &&
            value.location.length > 0 &&
            value.radiobutton == null
          ) {
            return each.location_country_id
              ? value.location.includes(each.location_country_id)
              : false
          }

          if (
            (value.keyword == null || value.keyword == '') &&
            value.location.length == 0 &&
            value.radiobutton != null
          ) {
            return each.job_type_name
              ? each.job_type_name.includes(value.radiobutton)
              : false
          }
          if (
            value.keyword != null &&
            value.keyword != '' &&
            value.location.length > 0 &&
            value.radiobutton == null
          ) {
            return (
              (each.location_country_name &&
              value.keyword &&
              value.location &&
              each.location_country_id
                ? each.location_country_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id)
                : false) ||
              (each.location_city_name &&
              value.keyword &&
              value.location &&
              each.location_country_id
                ? each.location_city_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id)
                : false) ||
              (each.short_name &&
              value.keyword &&
              value.location &&
              each.location_country_id
                ? each.short_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id)
                : false) ||
              (each.company_name &&
              value.keyword &&
              value.location &&
              each.location_country_id
                ? each.company_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id)
                : false) ||
              (each.location_city_name &&
              value.keyword &&
              value.location &&
              each.location_country_id
                ? each.location_city_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id)
                : false) ||
              (each.reward &&
              value.keyword &&
              value.location &&
              each.location_country_id
                ? String(each.reward).includes(value.keyword) &&
                  value.location.includes(each.location_country_id)
                : false)
            )
          }
          if (
            value.keyword != null &&
            value.keyword != '' &&
            value.location.length == 0 &&
            value.radiobutton != null
          ) {
            return (
              (each.location_country_name &&
              value.keyword &&
              value.radiobutton &&
              each.job_type_name
                ? each.location_country_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.radiobutton.includes(each.job_type_name)
                : false) ||
              (each.location_city_name &&
              value.keyword &&
              value.radiobutton &&
              each.job_type_name
                ? each.location_city_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.radiobutton.includes(each.job_type_name)
                : false) ||
              (each.short_name &&
              value.keyword &&
              value.radiobutton &&
              each.job_type_name
                ? each.short_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.radiobutton.includes(each.job_type_name)
                : false) ||
              (each.company_name &&
              value.keyword &&
              value.radiobutton &&
              each.job_type_name
                ? each.company_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.radiobutton.includes(each.job_type_name)
                : false) ||
              (each.location_city_name &&
              value.keyword &&
              value.radiobutton &&
              each.job_type_name
                ? each.location_city_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.radiobutton.includes(each.job_type_name)
                : false) ||
              (each.reward &&
              value.keyword &&
              value.radiobutton &&
              each.job_type_name
                ? String(each.reward).includes(value.keyword) &&
                  value.radiobutton.includes(each.job_type_name)
                : false)
            )
          }
          if (
            (value.keyword == null || value.keyword == '') &&
            value.location.length > 0 &&
            value.radiobutton != null
          ) {
            return each.job_type_name &&
              each.location_country_id &&
              value.location &&
              value.radiobutton
              ? each.job_type_name.includes(value.radiobutton) &&
                  value.location.includes(each.location_country_id)
              : false
          }
          if (
            value.keyword != null &&
            value.keyword != '' &&
            value.location.length > 0 &&
            value.radiobutton != null
          ) {
            return (
              (each.location_country_name &&
              value.keyword &&
              value.location &&
              each.location_country_id &&
              each.job_type_name &&
              value.radiobutton
                ? each.location_country_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id) &&
                  each.job_type_name.includes(value.radiobutton)
                : false) ||
              (each.location_city_name &&
              value.keyword &&
              value.location &&
              each.location_country_id &&
              each.job_type_name &&
              value.radiobutton
                ? each.location_city_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id) &&
                  each.job_type_name.includes(value.radiobutton)
                : false) ||
              (each.short_name &&
              value.keyword &&
              value.location &&
              each.location_country_id &&
              each.job_type_name &&
              value.radiobutton
                ? each.short_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id) &&
                  each.job_type_name.includes(value.radiobutton)
                : false) ||
              (each.company_name &&
              value.keyword &&
              value.location &&
              each.location_country_id &&
              each.job_type_name &&
              value.radiobutton
                ? each.company_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id) &&
                  each.job_type_name.includes(value.radiobutton)
                : false) ||
              (each.location_city_name &&
              value.keyword &&
              value.location &&
              each.location_country_id &&
              each.job_type_name &&
              value.radiobutton
                ? each.location_city_name
                    .toLowerCase()
                    .includes(value.keyword.toLowerCase()) &&
                  value.location.includes(each.location_country_id) &&
                  each.job_type_name.includes(value.radiobutton)
                : false) ||
              (each.reward &&
              value.keyword &&
              value.location &&
              each.location_country_id &&
              each.job_type_name &&
              value.radiobutton
                ? String(each.reward).includes(value.keyword) &&
                  value.location.includes(each.location_country_id) &&
                  each.job_type_name.includes(value.radiobutton)
                : false)
            )
          } else {
            return (this.jobOpenings = this.filterData)
          }
        })
      } else {
        this.jobOpenings = this.jobResult
        let today = moment(new Date()).format('YYYY-MM-DD')
        let thisweek = moment(new Date()).subtract(7, 'd').format('YYYY-MM-DD')
        let thismonth = moment(new Date())
          .subtract(30, 'd')
          .format('YYYY-MM-DD')

        if (value.jobTypes != null) {
          if (value.jobTypes != 'All Job Types') {
            this.jobTypes = value.jobTypes
          } else {
            this.jobTypes = ''
          }
        }
        if (value.workTypes != null) {
          if (value.workTypes != 'Any') {
            this.workTypes = value.workTypes
          } else {
            this.workTypes = ''
          }
        }
        if (value.datePosteds != null) {
          if (value.datePosteds != 'Any') {
            if (value.datePosteds == 'Today') {
              this.datePosteds = today
            }
            if (value.datePosteds == 'This Week') {
              this.datePosteds = thisweek
            }
            if (value.datePosteds == 'This Month') {
              this.datePosteds = thismonth
            }
          } else {
            this.datePosteds = ''
          }
        }

        this.filterLength = this.jobFilters.length
      }
    },
    result() {
      let filterJobs = this.createdjobtypes.filter(
        (each) => each.description == this.jobTypes
      )
      this.loading = true
      this.jobOpeningsLoading = true
      this.user.sqlId = 3

      let parameters = [
        { parameter_name: 'pin_job_opening_id', parameter_value: -1 },
        { parameter_name: 'pin_city_id', parameter_value: -1 },
        {
          parameter_name: 'pin_country_id',
          parameter_value: this.location ? Number(this.location[0].id) : -1,
        },
        { parameter_name: 'pin_company_id', parameter_value: -1 },
        { parameter_name: 'pin_status_id', parameter_value: 1 },
        { parameter_name: 'pin_assigned_company_user_id', parameter_value: -1 },
        {
          parameter_name: 'pin_assigned_internal_user_id',
          parameter_value: -1,
        },
        {
          parameter_name: 'piv_search_text',
          parameter_value: this.keyword ? this.keyword : '',
        },
        { parameter_name: 'pin_recruitment_type_id', parameter_value: -1 },
        {
          parameter_name: 'pin_job_type_id',
          parameter_value: filterJobs.length > 0 ? filterJobs[0].id : -1,
        },
        {
          parameter_name: 'pin_is_remote',
          parameter_value:
            this.workTypes == 'Remote'
              ? 2
              : this.workTypes == 'Onsite'
              ? 1
              : this.workTypes == 'Hybrid'
              ? 3
              : -1,
        },
        {
          parameter_name: 'piv_posted_after_date',
          parameter_value: this.datePosteds,
        },
      ]
      this.user.parameters = JSON.stringify(parameters)
      post('Commons/Executer', this.user)
        .then((data) => {
          if (data) {
            this.jobOpenings = data
            this.jobResult = data
          }
        })
        .finally(() => {
          this.loading = false
          this.jobOpeningsLoading = false
        })
    },
    clear() {
      this.isFilter = false
      this.keyword = null
      this.date_Posted = 'Any'
      this.job_Type = 'All Job Types'
      this.work_Type = 'Any'
      this.filterLength = null
      this.jobdesc = null
      this.jobOpenings = this.jobResult
      this.location = []
      this.tableFilter = {
        location: [],
        keyword: null,
        radiobutton: null,
      }
      this.keyword = null

      // Increment filterComponentKey to force HomeFilter component re-render
      this.filterComponentKey++

      // Force HomeFilter component to update by triggering a prop change
      this.$nextTick(() => {
        // This ensures the HomeFilter component receives the updated props
        this.date_Posted = this.$t('any')
        this.job_Type = this.$t('alljobs')
        this.work_Type = this.$t('any')
      })
    },
    getStarted() {
      this.$router.push({
        name: 'getStarted',
      })
    },
    detailJob(data) {
      if (this.location || this.keyword) {
        setItem('search-parameter', {
          location: this.location,
          keyword: this.keyword,
        })
        setItem('jobOpenings', this.jobOpenings)
      }
      this.$router.push({
        name: 'jobDetail',
        params: {
          name: data.name,
          id: data.id,
        },
      })
    },
    home() {
      this.$router.push({ name: 'home' })
    },
    login() {
      this.$router.push({ name: 'login' })
    },
    toggle(data) {
      this.isOpen = data
      if (this.topsize == false) {
        this.topsize = true
      } else {
        this.topsize = false
      }
    },

    getAllJobs() {
      if (getItem('search-parameter')) {
        removeItem('search-parameter')
      }
      if (getItem('jobOpenings')) {
        removeItem('jobOpenings')
      }
      this.clear()
      this.handleLogin('tumveriler')
    },
    filterKey(value) {
      value.length > 0 ? (value = value[0].id) : ''
      typeof value == 'number' ? (value = String(value)) : value

      if (value != '' && value != null) {
        this.jobOpenings = this.jobOpenings.filter(
          (each) =>
            // (each.location_country_id&&this.location?String(each.location_country_id).includes(this.location))
            (each.location_country_id
              ? each.location_country_id == value
              : false) ||
            (each.short_name
              ? each.short_name.toLowerCase().includes(value.toLowerCase())
              : false) ||
            (each.company_name
              ? each.company_name.toLowerCase().includes(value.toLowerCase())
              : false) ||
            (each.location_city_name
              ? each.location_city_name
                  .toLowerCase()
                  .includes(value.toLowerCase())
              : false) ||
            (each.location_country_name
              ? each.location_country_name
                  .toLowerCase()
                  .includes(value.toLowerCase())
              : false) ||
            (each.reward ? String(each.reward).includes(value) : false)
        )
      } else {
        this.jobOpenings = this.jobResult
      }
    },
    handleLogin(data) {
      this.submitted = true
      this.jobOpeningsLoading = true
      this.loading = true
      this.user.sqlId = 3
      let countryId = -1

      if (this.location) {
        this.location.map((each) => {
          if (countryId == '') {
            countryId = countryId + each.id
          } else {
            countryId = countryId + ',' + each.id
          }
        })
      }
      let parameters = [
        { parameter_name: 'pin_job_opening_id', parameter_value: -1 },
        { parameter_name: 'pin_city_id', parameter_value: -1 },
        {
          parameter_name: 'pin_country_id',
          parameter_value: countryId ? countryId : -1,
        },
        { parameter_name: 'pin_company_id', parameter_value: -1 },
        { parameter_name: 'pin_status_id', parameter_value: 1 },
        { parameter_name: 'pin_assigned_company_user_id', parameter_value: -1 },
        {
          parameter_name: 'pin_assigned_internal_user_id',
          parameter_value: -1,
        },
        {
          parameter_name: 'piv_search_text',
          parameter_value: this.keyword ? this.keyword : '',
        },
        { parameter_name: 'pin_recruitment_type_id', parameter_value: -1 },
        { parameter_name: 'pin_job_type_id', parameter_value: -1 },
        { parameter_name: 'pin_is_remote', parameter_value: -1 },
        { parameter_name: 'piv_posted_after_date', parameter_value: '' },
      ]
      this.user.parameters = JSON.stringify(parameters)
      post('Commons/Executer', this.user)
        .then((data) => {
          if (data) {
            if (this.location || this.keyword) {
              setItem('search-parameter', {
                location: this.location,
                keyword: this.keyword,
              })
            }
            this.jobOpenings = data
            this.jobResult = data
          }
        })
        .catch((err) => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: err.message,
            life: 3000,
          })
        })
        .finally(() => {
          this.loading = false
          this.jobOpeningsLoading = false
        })
    },

    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    handleClearFilters() {
      // Call the clear method to reset all filters
      this.clear()

      // Ensure HomeFilter component is notified about the reset
      this.$nextTick(() => {
        // This ensures the HomeFilter component receives the updated props
        this.date_Posted = this.$t('any')
        this.job_Type = this.$t('alljobs')
        this.work_Type = this.$t('any')

        // Increment filterComponentKey to force HomeFilter component re-render
        this.filterComponentKey++
      })
    },
    handleKeywordChange(event) {
      // Handle empty keyword values
      const value = event.target.value

      // If keyword is empty, reset the filter and show all results
      if (!value || value.trim() === '') {
        this.keyword = ''
        this.tableFilter.keyword = null

        // Only reset results if there are no other active filters
        if (
          this.tableFilter.location.length === 0 &&
          !this.tableFilter.radiobutton
        ) {
          this.jobOpenings = this.jobResult
          this.isFilter = false
        } else {
          // Re-apply other filters
          this.radioButtonFilter(this.tableFilter)
        }
      } else {
        // Apply the filter with the new keyword value
        this.filterTable(value, 'keyword')
      }

      // Force component update
      this.filterComponentKey++
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    showEmptyState() {
      // Loading durumunda empty state'i gösterme
      if (this.jobOpeningsLoading) {
        return false
      }

      return (
        !this.loading &&
        (!this.jobOpenings ||
          this.jobOpenings.length === 0 ||
          (this.keyword && this.jobOpenings.length === 0))
      )
    },
    emptyStateTitle() {
      if (
        this.keyword &&
        (!this.jobOpenings || this.jobOpenings.length === 0)
      ) {
        return 'No Search Results'
      }
      if (this.isFilter) {
        return 'No Matching Jobs Found'
      }
      return 'No Active Job Openings'
    },
    emptyStateDescription() {
      if (
        this.keyword &&
        (!this.jobOpenings || this.jobOpenings.length === 0)
      ) {
        return "We couldn't find any jobs matching your search terms. Try using different keywords."
      }
      if (this.isFilter) {
        return 'No jobs match your selected filters. Try adjusting or clearing the filters to see more results.'
      }
      return 'Currently, there are no active job openings available in the system. Please check back later.'
    },
  },
  components: {
    HomeFilter,
    HomeDataTable,
    Refer,
    Apply,
    EmptyState,
  },
}
</script>

<style lang="scss" scoped>
::v-deep(label) {
  margin-bottom: 0px !important;
}

::v-deep(.p-radiobutton-icon) {
  transform: translateZ(0) scale(1, 1) translate(-3.5%, -5%);
}

.p-multiselect {
  width: 18rem;
}

::v-deep(.multiselect-custom) {
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 1rem;
    padding-bottom: 0.25rem;
  }

  .country-item-value {
    padding: 0.25rem 0.5rem;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: #e4e4e4;
    color: #212529;
    border-radius: 6px;

    .fi {
      font-size: 1.2rem;
      margin-right: 0.5rem;
    }
  }
}

.country-item {
  display: flex;
  align-items: center;
  padding: 1rem;

  .fi {
    font-size: 1.2rem;
    margin-right: 0.5rem;
  }
}

@media screen and (max-width: 640px) {
  .p-multiselect {
    width: 100%;
  }
}

::v-deep(.p-multiselect-items-wrapper) {
  li {
    color: #fc6c2a;
    background: #fc6d2a11;
  }
}

::v-deep(.p-carousel-container) {
  width: 1270px;
  height: 25rem;

  .p-carousel-next {
    width: 44px;
    height: 44px;
    background: #ffebcc;
    color: #015cac;
  }

  .p-carousel-prev {
    width: 44px;
    height: 44px;
    background: #ffebcc;
    color: #015cac;
  }
}

::v-deep(.p-carousel-indicators) {
  button {
    width: 13px !important;
    height: 13px !important;
    background: #fc6c2a !important;
    border-radius: 50% !important;
  }
}

.hometitle {
  max-width: 800px;
  width: 100%;

  @media (max-width: 500px) {
    font-size: 40px !important;
    line-height: unset !important;
  }
}

.absolute {
  @media (max-width: 1385px) {
    display: none;
  }
}
span.flag {
  display: inline-block;
  height: 30px;
  width: 44px;
}
img.flag {
  width: 30px;
}
.flag {
  background: url(https://primefaces.org/cdn/primevue/images/flag/flags_responsive.png)
    no-repeat;
  background-size: 100%;
  vertical-align: middle;
}
.flag-ad {
  background-position: 0 0.413223%;
}
.flag-ae {
  background-position: 0 0.826446%;
}
.flag-af {
  background-position: 0 1.239669%;
}
.flag-ag {
  background-position: 0 1.652893%;
}
.flag-ai {
  background-position: 0 2.066116%;
}
.flag-al {
  background-position: 0 2.479339%;
}
.flag-am {
  background-position: 0 2.892562%;
}
.flag-an {
  background-position: 0 3.305785%;
}
.flag-ao {
  background-position: 0 3.719008%;
}
.flag-aq {
  background-position: 0 4.132231%;
}
.flag-ar {
  background-position: 0 4.545455%;
}
.flag-as {
  background-position: 0 4.958678%;
}
.flag-at {
  background-position: 0 5.371901%;
}
.flag-au {
  background-position: 0 5.785124%;
}
.flag-aw {
  background-position: 0 6.198347%;
}
.flag-az {
  background-position: 0 6.61157%;
}
.flag-ba {
  background-position: 0 7.024793%;
}
.flag-bb {
  background-position: 0 7.438017%;
}
.flag-bd {
  background-position: 0 7.85124%;
}
.flag-be {
  background-position: 0 8.264463%;
}
.flag-bf {
  background-position: 0 8.677686%;
}
.flag-bg {
  background-position: 0 9.090909%;
}
.flag-bh {
  background-position: 0 9.504132%;
}
.flag-bi {
  background-position: 0 9.917355%;
}
.flag-bj {
  background-position: 0 10.330579%;
}
.flag-bm {
  background-position: 0 10.743802%;
}
.flag-bn {
  background-position: 0 11.157025%;
}
.flag-bo {
  background-position: 0 11.570248%;
}
.flag-br {
  background-position: 0 11.983471%;
}
.flag-bs {
  background-position: 0 12.396694%;
}
.flag-bt {
  background-position: 0 12.809917%;
}
.flag-bv {
  background-position: 0 13.22314%;
}
.flag-bw {
  background-position: 0 13.636364%;
}
.flag-by {
  background-position: 0 14.049587%;
}
.flag-bz {
  background-position: 0 14.46281%;
}
.flag-ca {
  background-position: 0 14.876033%;
}
.flag-cc {
  background-position: 0 15.289256%;
}
.flag-cd {
  background-position: 0 15.702479%;
}
.flag-cf {
  background-position: 0 16.115702%;
}
.flag-cg {
  background-position: 0 16.528926%;
}
.flag-ch {
  background-position: 0 16.942149%;
}
.flag-ci {
  background-position: 0 17.355372%;
}
.flag-ck {
  background-position: 0 17.768595%;
}
.flag-cl {
  background-position: 0 18.181818%;
}
.flag-cm {
  background-position: 0 18.595041%;
}
.flag-cn {
  background-position: 0 19.008264%;
}
.flag-co {
  background-position: 0 19.421488%;
}
.flag-cr {
  background-position: 0 19.834711%;
}
.flag-cu {
  background-position: 0 20.247934%;
}
.flag-cv {
  background-position: 0 20.661157%;
}
.flag-cx {
  background-position: 0 21.07438%;
}
.flag-cy {
  background-position: 0 21.487603%;
}
.flag-cz {
  background-position: 0 21.900826%;
}
.flag-de {
  background-position: 0 22.31405%;
}
.flag-dj {
  background-position: 0 22.727273%;
}
.flag-dk {
  background-position: 0 23.140496%;
}
.flag-dm {
  background-position: 0 23.553719%;
}
.flag-do {
  background-position: 0 23.966942%;
}
.flag-dz {
  background-position: 0 24.380165%;
}
.flag-ec {
  background-position: 0 24.793388%;
}
.flag-ee {
  background-position: 0 25.206612%;
}
.flag-eg {
  background-position: 0 25.619835%;
}
.flag-eh {
  background-position: 0 26.033058%;
}
.flag-er {
  background-position: 0 26.446281%;
}
.flag-es {
  background-position: 0 26.859504%;
}
.flag-et {
  background-position: 0 27.272727%;
}
.flag-fi {
  background-position: 0 27.68595%;
}
.flag-fj {
  background-position: 0 28.099174%;
}
.flag-fk {
  background-position: 0 28.512397%;
}
.flag-fm {
  background-position: 0 28.92562%;
}
.flag-fo {
  background-position: 0 29.338843%;
}
.flag-fr {
  background-position: 0 29.752066%;
}
.flag-ga {
  background-position: 0 30.165289%;
}
.flag-gd {
  background-position: 0 30.578512%;
}
.flag-ge {
  background-position: 0 30.991736%;
}
.flag-gf {
  background-position: 0 31.404959%;
}
.flag-gh {
  background-position: 0 31.818182%;
}
.flag-gi {
  background-position: 0 32.231405%;
}
.flag-gl {
  background-position: 0 32.644628%;
}
.flag-gm {
  background-position: 0 33.057851%;
}
.flag-gn {
  background-position: 0 33.471074%;
}
.flag-gp {
  background-position: 0 33.884298%;
}
.flag-gq {
  background-position: 0 34.297521%;
}
.flag-gr {
  background-position: 0 34.710744%;
}
.flag-gs {
  background-position: 0 35.123967%;
}
.flag-gt {
  background-position: 0 35.53719%;
}
.flag-gu {
  background-position: 0 35.950413%;
}
.flag-gw {
  background-position: 0 36.363636%;
}
.flag-gy {
  background-position: 0 36.77686%;
}
.flag-hk {
  background-position: 0 37.190083%;
}
.flag-hm {
  background-position: 0 37.603306%;
}
.flag-hn {
  background-position: 0 38.016529%;
}
.flag-hr {
  background-position: 0 38.429752%;
}
.flag-ht {
  background-position: 0 38.842975%;
}
.flag-hu {
  background-position: 0 39.256198%;
}
.flag-id {
  background-position: 0 39.669421%;
}
.flag-ie {
  background-position: 0 40.082645%;
}
.flag-il {
  background-position: 0 40.495868%;
}
.flag-in {
  background-position: 0 40.909091%;
}
.flag-io {
  background-position: 0 41.322314%;
}
.flag-iq {
  background-position: 0 41.735537%;
}
.flag-ir {
  background-position: 0 42.14876%;
}
.flag-is {
  background-position: 0 42.561983%;
}
.flag-it {
  background-position: 0 42.975207%;
}
.flag-jm {
  background-position: 0 43.38843%;
}
.flag-jo {
  background-position: 0 43.801653%;
}
.flag-jp {
  background-position: 0 44.214876%;
}
.flag-ke {
  background-position: 0 44.628099%;
}
.flag-kg {
  background-position: 0 45.041322%;
}
.flag-kh {
  background-position: 0 45.454545%;
}
.flag-ki {
  background-position: 0 45.867769%;
}
.flag-km {
  background-position: 0 46.280992%;
}
.flag-kn {
  background-position: 0 46.694215%;
}
.flag-kp {
  background-position: 0 47.107438%;
}
.flag-kr {
  background-position: 0 47.520661%;
}
.flag-kw {
  background-position: 0 47.933884%;
}
.flag-ky {
  background-position: 0 48.347107%;
}
.flag-kz {
  background-position: 0 48.760331%;
}
.flag-la {
  background-position: 0 49.173554%;
}
.flag-lb {
  background-position: 0 49.586777%;
}
.flag-lc {
  background-position: 0 50%;
}
.flag-li {
  background-position: 0 50.413223%;
}
.flag-lk {
  background-position: 0 50.826446%;
}
.flag-lr {
  background-position: 0 51.239669%;
}
.flag-ls {
  background-position: 0 51.652893%;
}
.flag-lt {
  background-position: 0 52.066116%;
}
.flag-lu {
  background-position: 0 52.479339%;
}
.flag-lv {
  background-position: 0 52.892562%;
}
.flag-ly {
  background-position: 0 53.305785%;
}
.flag-ma {
  background-position: 0 53.719008%;
}
.flag-mc {
  background-position: 0 54.132231%;
}
.flag-md {
  background-position: 0 54.545455%;
}
.flag-me {
  background-position: 0 54.958678%;
}
.flag-mg {
  background-position: 0 55.371901%;
}
.flag-mh {
  background-position: 0 55.785124%;
}
.flag-mk {
  background-position: 0 56.198347%;
}
.flag-ml {
  background-position: 0 56.61157%;
}
.flag-mm {
  background-position: 0 57.024793%;
}
.flag-mn {
  background-position: 0 57.438017%;
}
.flag-mo {
  background-position: 0 57.85124%;
}
.flag-mp {
  background-position: 0 58.264463%;
}
.flag-mq {
  background-position: 0 58.677686%;
}
.flag-mr {
  background-position: 0 59.090909%;
}
.flag-ms {
  background-position: 0 59.504132%;
}
.flag-mt {
  background-position: 0 59.917355%;
}
.flag-mu {
  background-position: 0 60.330579%;
}
.flag-mv {
  background-position: 0 60.743802%;
}
.flag-mw {
  background-position: 0 61.157025%;
}
.flag-mx {
  background-position: 0 61.570248%;
}
.flag-my {
  background-position: 0 61.983471%;
}
.flag-mz {
  background-position: 0 62.396694%;
}
.flag-na {
  background-position: 0 62.809917%;
}
.flag-nc {
  background-position: 0 63.22314%;
}
.flag-ne {
  background-position: 0 63.636364%;
}
.flag-nf {
  background-position: 0 64.049587%;
}
.flag-ng {
  background-position: 0 64.46281%;
}
.flag-ni {
  background-position: 0 64.876033%;
}
.flag-nl {
  background-position: 0 65.289256%;
}
.flag-no {
  background-position: 0 65.702479%;
}
.flag-np {
  background-position: 0 66.115702%;
}
.flag-nr {
  background-position: 0 66.528926%;
}
.flag-nu {
  background-position: 0 66.942149%;
}
.flag-nz {
  background-position: 0 67.355372%;
}
.flag-om {
  background-position: 0 67.768595%;
}
.flag-pa {
  background-position: 0 68.181818%;
}
.flag-pe {
  background-position: 0 68.595041%;
}
.flag-pf {
  background-position: 0 69.008264%;
}
.flag-pg {
  background-position: 0 69.421488%;
}
.flag-ph {
  background-position: 0 69.834711%;
}
.flag-pk {
  background-position: 0 70.247934%;
}
.flag-pl {
  background-position: 0 70.661157%;
}
.flag-pm {
  background-position: 0 71.07438%;
}
.flag-pn {
  background-position: 0 71.487603%;
}
.flag-pr {
  background-position: 0 71.900826%;
}
.flag-pt {
  background-position: 0 72.31405%;
}
.flag-pw {
  background-position: 0 72.727273%;
}
.flag-py {
  background-position: 0 73.140496%;
}
.flag-qa {
  background-position: 0 73.553719%;
}
.flag-re {
  background-position: 0 73.966942%;
}
.flag-ro {
  background-position: 0 74.380165%;
}
.flag-rs {
  background-position: 0 74.793388%;
}
.flag-ru {
  background-position: 0 75.206612%;
}
.flag-rw {
  background-position: 0 75.619835%;
}
.flag-sa {
  background-position: 0 76.033058%;
}
.flag-sb {
  background-position: 0 76.446281%;
}
.flag-sc {
  background-position: 0 76.859504%;
}
.flag-sd {
  background-position: 0 77.272727%;
}
.flag-se {
  background-position: 0 77.68595%;
}
.flag-sg {
  background-position: 0 78.099174%;
}
.flag-sh {
  background-position: 0 78.512397%;
}
.flag-si {
  background-position: 0 78.92562%;
}
.flag-sj {
  background-position: 0 79.338843%;
}
.flag-sk {
  background-position: 0 79.752066%;
}
.flag-sl {
  background-position: 0 80.165289%;
}
.flag-sm {
  background-position: 0 80.578512%;
}
.flag-sn {
  background-position: 0 80.991736%;
}
.flag-so {
  background-position: 0 81.404959%;
}
.flag-sr {
  background-position: 0 81.818182%;
}
.flag-ss {
  background-position: 0 82.231405%;
}
.flag-st {
  background-position: 0 82.644628%;
}
.flag-sv {
  background-position: 0 83.057851%;
}
.flag-sy {
  background-position: 0 83.471074%;
}
.flag-sz {
  background-position: 0 83.884298%;
}
.flag-tc {
  background-position: 0 84.297521%;
}
.flag-td {
  background-position: 0 84.710744%;
}
.flag-tf {
  background-position: 0 85.123967%;
}
.flag-tg {
  background-position: 0 85.53719%;
}
.flag-th {
  background-position: 0 85.950413%;
}
.flag-tj {
  background-position: 0 86.363636%;
}
.flag-tk {
  background-position: 0 86.77686%;
}
.flag-tl {
  background-position: 0 87.190083%;
}
.flag-tm {
  background-position: 0 87.603306%;
}
.flag-tn {
  background-position: 0 88.016529%;
}
.flag-to {
  background-position: 0 88.429752%;
}
.flag-tp {
  background-position: 0 88.842975%;
}
.flag-tr {
  background-position: 0 89.256198%;
}
.flag-tt {
  background-position: 0 89.669421%;
}
.flag-tv {
  background-position: 0 90.082645%;
}
.flag-tw {
  background-position: 0 90.495868%;
}
.flag-ty {
  background-position: 0 90.909091%;
}
.flag-tz {
  background-position: 0 91.322314%;
}
.flag-ua {
  background-position: 0 91.735537%;
}
.flag-ug {
  background-position: 0 92.14876%;
}
.flag-gb,
.flag-uk {
  background-position: 0 92.561983%;
}
.flag-um {
  background-position: 0 92.975207%;
}
.flag-us {
  background-position: 0 93.38843%;
}
.flag-uy {
  background-position: 0 93.801653%;
}
.flag-uz {
  background-position: 0 94.214876%;
}
.flag-va {
  background-position: 0 94.628099%;
}
.flag-vc {
  background-position: 0 95.041322%;
}
.flag-ve {
  background-position: 0 95.454545%;
}
.flag-vg {
  background-position: 0 95.867769%;
}
.flag-vi {
  background-position: 0 96.280992%;
}
.flag-vn {
  background-position: 0 96.694215%;
}
.flag-vu {
  background-position: 0 97.107438%;
}
.flag-wf {
  background-position: 0 97.520661%;
}
.flag-ws {
  background-position: 0 97.933884%;
}
.flag-ye {
  background-position: 0 98.347107%;
}
.flag-za {
  background-position: 0 98.760331%;
}
.flag-zm {
  background-position: 0 99.173554%;
}
.flag-zr {
  background-position: 0 99.586777%;
}
.flag-zw {
  background-position: 0 100%;
}

.empty-state-visible {
  ::v-deep(.p-datatable-wrapper),
  ::v-deep(.p-paginator-bottom) {
    display: none !important;
  }
}
</style>
